import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function ShortLinkPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/c/' + code)
      .then(r => r.json())
      .then(d => {
        if (d.token) navigate('/confirmar/' + d.token, { replace: true });
        else navigate('/', { replace: true });
      })
      .catch(() => navigate('/', { replace: true }));
  }, [code, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p style={{ color: '#8A9BA8', fontFamily: 'Manrope', fontSize: 16 }}>Cargando confirmación...</p>
    </div>
  );
}
